export const Colors = {
  primary: "#65B891",
  primaryMedium: "#ABD8C3",
  primaryLight: "#D6FFEF",
  primaryExtraLight: "#EBFFF7",
  primaryExtraLight2: "#F3FFFA",
  // #F1F9F5v
  secondary: "#00241B",
  secondaryBgOpacity: "rgb(0, 0, 0, 0.6)",
  white: "#FFFFFF",
  success: "#32CD32",
  error: "#FF0000",
  platinum: "#E5E4E2",
  trial: "#E5E4E2",

  grey: "#ADB3B7",
  greyDark: "#A9A9A9",
  greyLight: "#E4E6E7",
  greySteel: "#71797E",
  greyScrollBar: "#E7E7E7",
  inputBg: "#EBF0F6",

  tom: "#808990", // Roman Silverv
  tomSecondary: "#ADB3B7",
  jerry: "#C27F30", // Bronze
  spike: "#9A867F", // Cinereous
  tyke: "#C39989", // Lite Sandal
  locationRed: "#EA4335",

  logo1: "#00F95F",
  logo2: "#00E071",
  logo3: "#00B490",
  logo4: "#0086B0",
  logo5: "#005ECA",
  logo6: "#005ECA",
  logo7: "#001EF8",
  logo8: "#0014FF",
};
